import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, NgZone, OnDestroy, Output } from '@angular/core';

@Directive({
    selector: '[appLazyLoad]'
})
export class LazyLoadDirective implements AfterViewInit, OnDestroy {
    @Input() rootMargin = '300px 0px';
    @Input() threshold: number | number[] = 0.1;
    @Input() once = true; // trigger only once by default
    @Output() visible = new EventEmitter<void>();

    private observer?: IntersectionObserver;
    private hasEmitted = false;

    constructor(private el: ElementRef, private zone: NgZone) { }

    ngAfterViewInit(): void {
        // Run outside Angular to avoid unnecessary change detection on scroll
        this.zone.runOutsideAngular(() => {
            if ('IntersectionObserver' in window) {
                this.observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting || entry.intersectionRatio > 0) {
                            if (this.once && this.hasEmitted) {
                                return;
                            }
                            this.hasEmitted = true;
                            // Re-enter Angular zone to emit event
                            this.zone.run(() => this.visible.emit());
                            if (this.once) {
                                this.observer?.unobserve(this.el.nativeElement);
                                this.disconnect();
                            }
                        }
                    });
                }, { root: null, rootMargin: this.rootMargin, threshold: this.threshold });
                this.observer.observe(this.el.nativeElement);
            } else {
                // Fallback: if IntersectionObserver not supported, emit immediately
                this.zone.run(() => this.visible.emit());
            }
        });
    }

    ngOnDestroy(): void {
        this.disconnect();
    }

    private disconnect() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = undefined;
        }
    }
}
